var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArithmetic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 175C58.9775 175 25.4001 141.423 25.4001 100C25.4001 58.5774 58.9775 25 100.4 25C141.823 25 175.4 58.5774 175.4 100C175.4 141.423 141.823 175 100.4 175Z",
    fill: "url(#paint0_linear_26801_911)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4001 32C36.7727 32 31.4001 37.3726 31.4001 44V86.4114H85.8115V32H43.4001ZM71.0728 62.9858H62.3859V71.6726C62.3859 73.9444 60.8776 75.4527 58.6058 75.4527C56.334 75.4527 54.8257 73.9444 54.8257 71.6726V62.9858H46.1389C43.8671 62.9858 42.3588 61.4775 42.3588 59.2057C42.3588 56.9336 43.8671 55.4256 46.1389 55.4256H54.8257V46.7387C54.8257 44.4669 56.334 42.9586 58.6058 42.9586C60.8776 42.9586 62.3859 44.4669 62.3859 46.7387V55.4256H71.0728C73.3446 55.4256 74.8529 56.9336 74.8529 59.2057C74.8529 61.4775 72.9628 62.9858 71.0728 62.9858Z",
    fill: "url(#paint1_linear_26801_911)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3242 32V86.4114H145.736V44C145.736 37.3726 140.363 32 133.736 32H91.3242ZM130.997 62.9858H106.044C103.791 62.9858 102.283 61.4775 102.283 59.2057C102.283 56.9336 103.791 55.4256 106.044 55.4256H130.997C133.25 55.4256 134.777 56.9336 134.777 59.2057C134.777 61.4775 132.887 62.9858 130.997 62.9858Z",
    fill: "url(#paint2_linear_26801_911)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3242 91.9241V146.335H133.736C140.363 146.335 145.736 140.963 145.736 134.335V91.9241H91.3242ZM118.53 101.737C121.165 101.737 123.055 103.627 123.055 106.281C123.055 108.916 121.165 110.806 118.53 110.806C115.876 110.806 113.986 108.916 113.986 106.281C113.986 103.627 115.876 101.737 118.53 101.737ZM118.53 136.503C115.876 136.503 113.986 134.613 113.986 131.978C113.986 129.325 115.876 127.435 118.53 127.435C121.165 127.435 123.055 129.325 123.055 131.978C123.055 134.231 120.802 136.503 118.53 136.503ZM130.997 122.91H106.063C103.791 122.91 102.283 121.402 102.283 119.13C102.283 116.858 103.791 115.35 106.063 115.35H130.997C133.269 115.35 134.777 116.858 134.777 119.13C134.777 121.402 132.887 122.91 130.997 122.91Z",
    fill: "url(#paint3_linear_26801_911)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4001 91.9241V134.335C31.4001 140.963 36.7727 146.335 43.4001 146.335H85.8115V91.9241H31.4001ZM70.3279 125.182C71.8363 126.69 71.8363 128.943 70.3279 130.47C68.8201 131.978 66.5478 131.978 65.0395 130.47L58.9876 124.418L52.9356 130.47C51.4273 131.978 49.1555 131.978 47.6472 130.47C46.1389 128.943 46.1389 126.69 47.6472 125.182L53.6991 119.13L47.6472 113.078C46.1389 111.57 46.1389 109.298 47.6472 107.789C49.1555 106.281 51.4273 106.281 52.9356 107.789L58.9876 113.841L65.0395 107.789C66.5478 106.281 68.8201 106.281 70.3279 107.789C71.8363 109.298 71.8363 111.57 70.3279 113.078L64.276 119.13L70.3279 125.182Z",
    fill: "url(#paint4_linear_26801_911)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.613 122.191C142.106 122.191 137.701 123.527 133.953 126.031C130.206 128.535 127.285 132.094 125.561 136.258C123.836 140.422 123.385 145.003 124.264 149.424C125.143 153.844 127.313 157.904 130.5 161.091C133.687 164.278 137.747 166.448 142.167 167.327C146.588 168.207 151.169 167.755 155.333 166.031C159.497 164.306 163.056 161.385 165.56 157.638C168.064 153.891 169.4 149.485 169.4 144.978C169.393 138.937 166.99 133.145 162.718 128.873C158.447 124.601 152.654 122.198 146.613 122.191Z",
    fill: "url(#paint5_linear_26801_911)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.883 151.143C157.16 150.972 157.384 150.727 157.53 150.435C157.737 150.019 157.771 149.538 157.624 149.097C157.477 148.656 157.16 148.292 156.744 148.084L148.366 143.894V133.292C148.366 132.827 148.181 132.382 147.852 132.053C147.524 131.724 147.078 131.54 146.613 131.54C146.148 131.54 145.702 131.724 145.374 132.053C145.045 132.382 144.86 132.827 144.86 133.292V144.978C144.86 145.304 144.951 145.624 145.123 145.901C145.295 146.178 145.54 146.401 145.832 146.546L155.181 151.221C155.423 151.342 155.69 151.406 155.962 151.405C156.287 151.405 156.606 151.314 156.883 151.143Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_911",
    x1: 25.4001,
    y1: 36.7188,
    x2: 168.369,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_911",
    x1: 88.5679,
    y1: 32,
    x2: 88.5679,
    y2: 146.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_911",
    x1: 88.5679,
    y1: 32,
    x2: 88.5679,
    y2: 146.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_911",
    x1: 88.5679,
    y1: 32,
    x2: 88.5679,
    y2: 146.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_911",
    x1: 88.5679,
    y1: 32,
    x2: 88.5679,
    y2: 146.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_911",
    x1: 128.811,
    y1: 122.191,
    x2: 181.513,
    y2: 155.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArithmetic);
export default __webpack_public_path__ + "static/media/Arithmetic.5e180e5f4e18139ea6fa37ebed5686ea.svg";
export { ForwardRef as ReactComponent };